export const isMobileAppRedirectVisible = true
